let URLBASE;
try {
    URLBASE = require('./Ambiente.local.js').default;
} catch {
    URLBASE = require('./Ambiente.js').default;
}

export { URLBASE };
export const LOCALE = 'es-AR';
export const URLLOGIN = URLBASE + '/login';
export const URLLOGOUT = URLBASE + '/logout';

export const ID_ARGENTINA = 1;

export const ORDEN_TECNICOS = 90;
